import { render, staticRenderFns } from "./AdditionalForm.vue?vue&type=template&id=e14e8dc0&scoped=true"
import script from "./AdditionalForm.vue?vue&type=script&lang=js"
export * from "./AdditionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14e8dc0",
  null
  
)

export default component.exports